import Cookies from "js-cookie";
import aesjs from 'aes-js'

const aesJsKey = process.env.REACT_APP_AES_KEY
const aesIv = process.env.REACT_APP_AES_IV

class liveAuth {
  static timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  static encryptAvUserInfo = data => {
    const dataString = typeof data === 'string' ? data : JSON.stringify(data);

    // Key for encryption must be 16, 24, or 32 bytes (AES-128, AES-192, AES-256)
    const keys = aesjs.utils.utf8.toBytes(aesJsKey); // 16-byte key for AES-128

    const counter = new aesjs.Counter(aesjs.utils.utf8.toBytes(aesIv));

    // Convert string to bytes
    const textBytes = aesjs.utils.utf8.toBytes(dataString);

    // Encrypt using AES-CTR
    const aesCtr = new aesjs.ModeOfOperation.ctr(keys, counter);
    const encryptedByte = aesCtr.encrypt(textBytes);
    const encryptedHex = aesjs.utils.hex.fromBytes(encryptedByte);
    return encryptedHex
  }

  static decryptAvUserInfo = data => {
    const dataString = typeof data === 'string' ? data : JSON.stringify(data);

    // Key for encryption must be 16, 24, or 32 bytes (AES-128, AES-192, AES-256)
    const keys = aesjs.utils.utf8.toBytes(aesJsKey); // 16-byte key for AES-128
    let encryptedBytes = aesjs.utils.hex.toBytes(dataString);

    // Decrypt using the same key and counter
    const decryptCounter = new aesjs.Counter(aesjs.utils.utf8.toBytes(aesIv));
    const aesCtrDecrypt = new aesjs.ModeOfOperation.ctr(keys, decryptCounter);
    const decryptedBytes = aesCtrDecrypt.decrypt(encryptedBytes);

    // Convert decrypted bytes back to string
    const decryptedString = aesjs.utils.utf8.fromBytes(decryptedBytes);

    const decodedStr = decodeURIComponent(decryptedString);

    // Parse the decrypted string back into an object
    // const decryptedObject = JSON.parse(decodedStr);
    // console.log(decryptedObject)

    return decodedStr
  }

  static check() {
    let flag = false;
    const avUserInfo = this.getAvUserInfo()
    if (avUserInfo?.email) {
      flag = true;
    }
    return flag;
  }

  // without encryption
  static getAvUserInfo() {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes' && Cookies.get('local-avuserinfo')) {
      return JSON.parse(Cookies.get('local-avuserinfo'))
    } else if (window?.avUserInfoJS) {
      const jsonObject = JSON.parse(window.avUserInfoJS);
      return jsonObject;
    }
    return false;
  }

  static getAvUserInfoString() {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes') {
      return Cookies.get('local-avuserinfo')
    } else if (window?.avUserInfoJS) {
      return window.avUserInfoJS;
    }
    return false;
  }

  // For encryption
  // static getCookiAvUserInfo() {
  //   const avuserInfoCookie = `avUserInfo-${window.avnet.siteId}`
  //   return Cookies.get(avuserInfoCookie) ? Cookies.get(avuserInfoCookie) : false;
  // }

  // static getAvUserInfo() {

  //   if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes' && Cookies.get('local-avuserinfo')) {
  //     return JSON.parse(Cookies.get('local-avuserinfo'))
  //   } else {
  //     if (this.getCookiAvUserInfo()) {
  //       const jsonObject = JSON.parse(this.decryptAvUserInfo(this.getCookiAvUserInfo()));
  //       return jsonObject;
  //     } else {
  //       return window.avUserInfoJS ? JSON.parse(window.avUserInfoJS) : false
  //     }
  //   }
  //   // return false;
  // }

  // static getAvUserInfoString() {
  //   if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes') {
  //     return this.encryptAvUserInfo(Cookies.get('local-avuserinfo'))
  //   } else {
  //     return this.getCookiAvUserInfo() ? this.getCookiAvUserInfo() : window.avUserInfoJS ? this.encryptAvUserInfo(window.avUserInfoJS) : false;
  //   }
  // }

}

export default liveAuth;
